import { JSX } from 'react';
import { Dayjs } from 'dayjs';
import { mapScheduleDateData } from 'entities/schedulePublic/lib';
import { mappedTeacherSchedule } from 'entities/types';
import { mappedGroupSchedule } from 'entities/types';

import { TableSchedule } from '../../tableSchedule';

export const makeTables = (
  isGroupSchedule: boolean,
  data: mappedGroupSchedule | mappedTeacherSchedule,
  startDate: Dayjs,
  endDate: Dayjs,
) => {
  const res: JSX.Element[] = [];

  if (data.length === endDate.diff(startDate, 'day')) {
    const dataDateArray = mapScheduleDateData(startDate, endDate, data);
    data.forEach((item, index) => {
      res.push(
        <TableSchedule
          isGroupSchedule={isGroupSchedule}
          dataDate={dataDateArray[index]}
          dataSchedule={item}
          key={item[0] ? item[0].key : index}
        />,
      );
    });
  }

  return res;
};
